<section class="relative lg:flex md:sm:grid md:sm:grid-cols-1 items-center gap-4">
  <article class="lg:flex rounded h-10">
    <app-input-search [searchValue]="searchValue" [placeholder]="placeholder" (submitEventEmitter)="search($event)"></app-input-search>
  </article>
  @if (adminRole == 'SUPERADMIN' || adminRole == 'ADMIN') {
    <article class="lg:flex items-center">
      <app-custom-toggle
        [id]="'communications-header-toggle'"
        [selectedValue]="communicationUserType"
        [firstValue]="CommunicationUserTypes.USERS"
        [secondValue]="CommunicationUserTypes.DRIVERS"
        [firstImage]="images.suggestions.user"
        [secondImage]="images.suggestions.driver"
        [firstDescription]="literalService.get('users.userTypes.users', true)"
        [secondDescription]="literalService.get('users.userTypes.drivers', true)"
        [color]="'secondary'"
        (action)="changeCommunicationUserType()"
      />
    </article>
  }
  <article id="communicationType" class="relative lg:flex rounded" (click)="communicationTypeOpened = !communicationTypeOpened">
    <button id="buttonOpenCommunicationType" class="text-gray-800 font-bold px-4 py-2 rounded inline-flex items-center gap-2">
      <img [src]="images.suggestions[`${communicationType}Icon`]" alt="sort" class="w-6 h-6" />
      <span class="font-semibold text-base">{{
        literalService.get(`communications.types.${communicationType}`, true)
        }}</span>
    </button>
    <article id="communicationTypeModal" class="flex absolute mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !communicationTypeOpened }">
      <app-option-selector [id]="'communicationTypeSelector'" [componentOpen]="'buttonOpenCommunicationType'" [selectedOption]="communicationType" [options]="communicationTypesOptions" (onChange)="changeCommunicationType($event)" (close)="communicationTypeOpened = false" ></app-option-selector>
    </article>
  </article>
  <article class="relative lg:flex rounded" (click)="filterOpened = !filterOpened">
    <button id="buttonOpenFilter" class="text-gray-800 font-bold px-4 py-2 rounded inline-flex items-center gap-2"
      [ngClass]="{ 'opened' : filterOpened, 'filtersApplied': filtersApplied > 0 }">
      <img [src]="images.filter" alt="filter" class="w-6 h-6" [ngClass]="{ 'filterOpened': filterOpened || filtersApplied > 0 }" />
      <span class="font-semibold text-base">{{ literalService.get("communications.filter", true) }}</span>
    </button>
    @if (filtersApplied > 0) {
      <div class="filter-bubble w-4 h-4 absolute -top-2 -right-2 flex justify-center items-center p-2.5 rounded-full text-xs font-bold">
        {{ filtersApplied }}
      </div>
    }
  </article>
  @if (communicationType === CommunicationTypes.SUGGESTIONS) {
    <article class="flex absolute self-start top-0 left-0 mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !filterOpened}">
      <app-suggestion-filter [isFilterOpen]="filterOpened" [componentOpen]="'buttonOpenFilter'" [communicationUserType]="communicationUserType" (filter)="filter.emit($event)" (closeFilter)="closeFilter()"></app-suggestion-filter>
    </article>
  }
  @else {
    <article class="flex absolute self-start top-0 left-0 mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !filterOpened}">
      <app-message-filter [isFilterOpen]="filterOpened" [componentOpen]="'buttonOpenFilter'" [communicationUserType]="communicationUserType" (filter)="filter.emit($event)" (closeFilter)="closeFilter()"
       ></app-message-filter>
    </article>
  }
  @if (communicationType === CommunicationTypes.SUGGESTIONS) {
    <article id="sort" class="relative lg:flex rounded" (click)="sortedOpened = !sortedOpened">
      <button id="buttonOpenSort" class="text-gray-800 font-bold px-4 py-2 rounded inline-flex items-center gap-2">
        <img [src]="images.sort" alt="sort" class="w-6 h-6" />
        <span class="font-semibold text-base">{{
          literalService.get("communications.sort", true)
          }}</span>
      </button>
      <article id="sortModal" class="flex absolute mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !sortedOpened }">
        <app-option-selector [id]="'suggestionsSortSelector'" [componentOpen]="'buttonOpenSort'" [title]="'orderBy'" [selectedOption]="suggestionSortTypeSelected" [options]="sortOptions" (onChange)="handleSort($event)" (close)="sortedOpened = false" ></app-option-selector>
      </article>
    </article>
  }
  @if (searching) {
    <article class="flex items-center pb-2">
      <img [src]="images.loading" alt="loading" class="h-10 w-10 ml-4" />
      <label class="font-semibold text-base ml-4">{{ literalService.get(`communications.searching`, true) }}...</label>
    </article>
  }
  <section class="flex ml-auto max-h-10">
    <article
      class="lg:flex w-full rounded-[30px] px-3 py-1.5 inline-flex gap-1.5 justify-center items-center ml-auto cursor-pointer outlinedButton"
      (click)="addCommunicationEventEmitter.emit()"
    >
      <img [src]="images.suggestions.addSuggestion" alt="addSuggestion" class="w-5.5 h-5.5" />
      <span class="font-semibold text-base"> {{ literalService.get(`${communicationType}.new`, true) }} </span>
    </article>
  </section>
</section>